export default {
      id: "vk_id1-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#vk_id1",
      toString: function () {
        return this.url;
      }
    }